import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { supabase } from "./SupabaseClient";
const Register = () => {
  const [user, setUser] = useState(null);

  const [email, setEmail] = useState("");
  // const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    setEmail("");
    //setUsername("");
    setPassword("");
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    const { data: loginData, error } = await supabase.auth.signInWithPassword({
      email: email,
      password: password,
    });

    if (error) {
      alert("Login failed: " + error.message);
      return;
    }

    const loggedInUser = loginData.user;
    console.log("Logged in user:", loggedInUser);

    const { data: profile, error: profileError } = await supabase
      .from("profiles")
      .select("username")
      .eq("id", loggedInUser.id)
      .single();
    if (profileError) {
      console.error("Failed to fetch profile:", profileError.message);
    }

    // Pass user + username to App.js
    setUser({ ...loggedInUser, username: profile?.username });
    alert("Logged in successfully:");
    navigate("/ExpenseForm");
  };

  return (
    <>
      <h1>Login</h1>
      <form name="login" onSubmit={handleSubmit}>
        <label
          htmlFor="email"
          className="email"
          placeholder="johndoe@example.com"
        >
          Email
        </label>
        <input
          autoComplete="off"
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <label htmlFor="password" className="password" placeholder="123$">
          Password
        </label>
        <input
          autoComplete="off"
          type="password"
          value={password}
          id="password"
          onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit" onClick={handleLogin}>
          Login
        </button>
        <Link to="/Register">Back to Register</Link>
      </form>
    </>
  );
};
export default Register;
